import { defineComponent } from "vue";

// 内联 SVG 图标集（不引入图标库、不使用外链字体图标）
function renderPath(name: string) {
  switch (name) {
    case "search":
      return (
        <g>
          <circle cx="11" cy="11" r="7" />
          <path d="M20 20l-3.6-3.6" />
        </g>
      );
    case "clock":
      return (
        <g>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </g>
      );
    case "eye":
      return (
        <g>
          <path d="M2.5 12S6 6 12 6s9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6z" />
          <circle cx="12" cy="12" r="3" />
        </g>
      );
    case "phone":
      return (
        <path d="M6 3h3l2 5-2.4 1.6a12 12 0 0 0 5.8 5.8L16 13l5 2v3a2 2 0 0 1-2.2 2A17 17 0 0 1 4 5.2 2 2 0 0 1 6 3z" />
      );
    case "arrow-right":
      return (
        <g>
          <path d="M4 12h15" />
          <path d="M13 6l6 6-6 6" />
        </g>
      );
    case "chevron-left":
      return <path d="M14 6l-6 6 6 6" />;
    case "chevron-right":
      return <path d="M10 6l6 6-6 6" />;
    case "box":
      return (
        <g>
          <path d="M3 7l9-4 9 4v10l-9 4-9-4z" />
          <path d="M3 7l9 4 9-4" />
          <path d="M12 11v10" />
        </g>
      );
    case "home":
      return (
        <g>
          <path d="M3 11l9-8 9 8" />
          <path d="M6 10v10h12V10" />
        </g>
      );
    case "car":
      return (
        <g>
          <path d="M4 16v-4l2-5h12l2 5v4" />
          <path d="M3 16h18" />
          <circle cx="7.5" cy="18.5" r="1.5" />
          <circle cx="16.5" cy="18.5" r="1.5" />
        </g>
      );
    case "tool":
      return (
        <path d="M15 3a5 5 0 0 0-4.6 7L4 16.4V20h3.6l6.4-6.4A5 5 0 1 0 15 3z" />
      );
    case "doc":
      return (
        <g>
          <path d="M6 3h8l4 4v14H6z" />
          <path d="M14 3v4h4" />
        </g>
      );
    case "shield":
      return <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" />;
    case "alert":
      return (
        <g>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 8v5" />
          <path d="M12 16h.01" />
        </g>
      );
    case "check":
      return (
        <g>
          <circle cx="12" cy="12" r="9" />
          <path d="M8 12.5l2.8 2.8L16 9.5" />
        </g>
      );
    case "inbox":
      return (
        <g>
          <path d="M3 13l3-8h12l3 8v6H3z" />
          <path d="M3 13h5l1 2h6l1-2h5" />
        </g>
      );
    case "filter":
      return <path d="M4 5h16l-6 7v6l-4-2v-4z" />;
    default:
      return <circle cx="12" cy="12" r="9" />;
  }
}

export const Icon = defineComponent({
  name: "XiyouIcon",
  props: {
    name: { type: String, required: true },
  },
  setup(props) {
    return () => (
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        style={{ verticalAlign: "-0.125em" }}
      >
        {renderPath(props.name)}
      </svg>
    );
  },
});
